import { showPopup } from "@/components/warnings/Popup";
import { useState, useEffect } from "react";

export function useFuelCost() {
  const [fuelCost, setFuelCost] = useState<string>("");
  
  useEffect(() => {
    if (fuelCost) localStorage.setItem("fuelCost", fuelCost);
  }, [fuelCost]);

  const onClearFuelCost = () => {
    setFuelCost("");
  }

  const setValidFuelCost = (value: string) => {
    // Allow empty string to let user clear input
    if (value === "" || /^(\d+\.?\d*|\.\d+)$/.test(value)) {
      setFuelCost(value);
    } else {
      showPopup(
        'Invalid fuel price input.',
        'Input Error'
      )
    }
  };

  return { fuelCost, setValidFuelCost, onClearFuelCost };
}
